module.exports = __webpack_public_path__ + "assets/img/zls.f047b2b3.png";